import { useEffect, useMemo, useState } from "react";
import { companyModalConfig } from "../../superdashboard/config/superDashboardConfig";
import useHistogramToggle from "./useHistogramToggle";

const DEFAULT_PAGE_SIZE = 10;

const useCompanyModalState = ({ open, configKey, dashboardData}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const { isHistogramView, toggleView, resetView } = useHistogramToggle();

  const cfg = companyModalConfig?.[configKey];
  const title = cfg?.title || "";
  const columns = cfg?.columns || [];
  const histogramDataKey = cfg?.columns?.[cfg?.histogramColumnIndex]?.dataKey;
  const data = cfg?.getCompanies?.(dashboardData) || [];

  useEffect(() => {
    if (open) setCurrentPage(1);
    resetView();
  }, [open, pageSize]);

  const companies = data || [];
  const totalCount = companies.length;
  const totalPages = Math.ceil(totalCount / pageSize);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return companies.slice(startIndex, startIndex + pageSize);
  }, [companies, currentPage, pageSize]);

  const startEntry = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endEntry = Math.min(currentPage * pageSize, totalCount);

  return {
    title,
    columns,
    histogramDataKey,
    isHistogramView,
    toggleView,
    companies,
    paginatedData,
    paginationProps: {
      startEntry,
      endEntry,
      totalCount,
      totalPages,
      pageSize,
      currentPage,
      onPageChange: setCurrentPage,
      onPageSizeChange: setPageSize
    }
  };
};

export default useCompanyModalState;
